document.addEventListener("DOMContentLoaded", () => {

  function moveBell() {
    const bell = document.querySelector('.wisepops-shopify.wisp');
    const target = document.querySelector('.header__buttons a[href="/account"]');

    if (!bell || !target) {
      setTimeout(moveBell, 300);
      return;
    }

    // Prevent duplicate injection
    if (document.querySelector('.header-bell-injected')) return;

    const bellWrapper = bell.closest('.shopify-app-block');
    const outerSection = bellWrapper?.closest('.section.section--padding');

    if (!bellWrapper || !outerSection) {
      setTimeout(moveBell, 300);
      return;
    }

    // Clone bell
    const clone = bell.cloneNode(true);

    // Reset classes exactly as requested
    clone.className = "wisepops-shopify wisp header-bell-injected wisp_ready";

    // Apply container dimensions/styles
    clone.style.width = "44px";
    clone.style.height = "44px";
    clone.style.display = "flex";
    clone.style.alignItems = "center";
    clone.style.justifyContent = "center";

    // Update SVG size
    const svg = clone.querySelector("svg");
    if (svg) {
      svg.style.width = "32px";
      svg.style.height = "28px";
    }

    // Insert next to profile icon
    target.insertAdjacentElement("afterend", clone);

  }

  moveBell();
});
